import { IndividualConfig } from 'ngx-toastr';

export const toastrConfig: Partial<IndividualConfig> = {
  enableHtml: true,
  closeButton: true,
  timeOut: 10000,
};
